<template>
  <ListItem component="button" type="button" @click="$emit('click', 'title')">
    <ListItemAction>
      <TitleIcon size="1.5rem" />
    </ListItemAction>
    <ListItemContent>
      <ListItemTitle>Title</ListItemTitle>
      <ListItemSubtitle wrap
        >Organize your links with a title.</ListItemSubtitle
      >
    </ListItemContent>
  </ListItem>
</template>

<script>
import {
  ListItem,
  ListItemAction,
  ListItemContent,
  ListItemSubtitle,
  ListItemTitle,
  TitleIcon,
} from '@campsite-bio/component-lib';

export default {
  components: {
    ListItem,
    ListItemAction,
    ListItemContent,
    ListItemSubtitle,
    ListItemTitle,
    TitleIcon,
  },
};
</script>

<style lang="scss" scoped></style>
